module.exports = __webpack_public_path__ + "img/140.db12c73d.jpg";